export default function Testimonials() {
  const testimonials = [
    {
      text: "Este libro nos ayudó a tener conversaciones que nunca habíamos tenido. Mi hijo ahora expresa lo que siente sin miedo.",
      author: "María González",
      role: "Mamá de dos niños"
    },
    {
      text: "Lo leemos antes de dormir. Se ha convertido en nuestro momento favorito del día.",
      author: "Carlos Ramírez",
      role: "Papá de una niña"
    },
    {
      text: "Como mamá, me enseñó a acompañar desde la calma y no desde la reacción.",
      author: "Ana Martínez",
      role: "Madre de familia"
    },
    {
      text: "No es solo un libro para niños, es una guía para toda la familia.",
      author: "Laura Fernández",
      role: "Mamá y educadora"
    }
  ];

  return (
    <section id="testimonials" className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-rose-50 to-amber-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
            💬 Lo que dicen las familias<br />
            que ya lo leyeron
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-800 max-w-3xl mx-auto font-medium">
            Testimonios reales de padres que transformaron su conexión familiar
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all group hover:scale-105"
            >
              <div className="flex gap-1 mb-4 sm:mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-lg sm:text-xl"></i>
                ))}
              </div>
              <p className="text-gray-800 text-base sm:text-lg leading-relaxed mb-4 sm:mb-6 italic font-medium">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center text-white font-bold text-lg sm:text-xl flex-shrink-0">
                  {testimonial.author.charAt(0)}
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-sm sm:text-base">{testimonial.author}</p>
                  <p className="text-gray-700 text-xs sm:text-sm font-medium">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
